import React from 'react';
// Import Shared Components
import { Card, Title, Table, Button, ActionBar } from 'shared-components';
// Import Utils
import { formatCurrencyV } from 'shared-components/src/utils/formatCurrency';
import { centsToDollars } from 'shared-components/src/utils/currency';

export default function({
  valueUnloads,
  setValueUnloads,
  setLoadStep,
  setSuccess,
  setError,
  handleValueUnloadSubmit,
}) {

  const columns = [
    {
      Header: 'Account Id',
      accessor: 'account_id'
    },
    {
      Header: 'External Tag',
      accessor: 'external_tag'
    },
    {
      Header: 'Message',
      accessor: 'message'
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      Cell: ({ value }) => formatCurrencyV(centsToDollars(value))
    },
  ];

  return (
    <Card>
      <Title>Value Unloads</Title>
      <p>
        <i>
          Please take the time to review the uploaded value unload information
          below for correctness before completing.
        </i>
      </p>
      <Table columns={columns} data={valueUnloads} />
      <ActionBar justifyContent="space-between">
        <Button
          type="secondary"
          onClick={() => {
            setValueUnloads([]);
            setLoadStep(1);
            setSuccess(null);
            setError(null);
          }}
        >
          Back
        </Button>
        <Button type="primary" onClick={() => handleValueUnloadSubmit()}>
          Create Value Unloads
        </Button>
      </ActionBar>
    </Card>
  );
};
